'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _VideoPreview = require('./components/VideoPreview');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_VideoPreview).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/shared-ugc-editors/lib/components/video-preview/index.js
// module id = 371
// module chunks = 1